import React from 'react'

export default function DemoError() {
  return (
    <div>In order to get to the demo page, you must be logged out.</div>
  )
}
